import _classCallCheck from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _inherits from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _createSuper from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/createSuper.js";
import { __decorate } from "tslib";
import Component from "vue-class-component";
import Vue from "vue"; // import Components from "./incisione/index";

import ComponenteIncisione from "./personalizzazioni/ComponenteIncisione.vue";

var Personalizzazioni = /*#__PURE__*/function (_Vue) {
  _inherits(Personalizzazioni, _Vue);

  var _super = _createSuper(Personalizzazioni);

  function Personalizzazioni() {
    var _this;

    _classCallCheck(this, Personalizzazioni);

    _this = _super.apply(this, arguments);
    _this.namePosition = "ext";
    _this.selectedItem = "";
    return _this;
  }

  _createClass(Personalizzazioni, [{
    key: "persComponents",
    get: function get() {
      var frontale = {
        id: 1,
        label: "message.frontale",
        "int": false,
        ext: false,
        nome: "Frontale",
        testo: "",
        colore: ""
      };

      if (this.materiale == "MT") {
        return [frontale];
      }

      return [frontale, {
        id: 2,
        label: "message.Asta_destra",
        "int": true,
        ext: true,
        nome: "AstaDx",
        testo: "",
        colore: ""
      }, {
        id: 3,
        label: "message.Asta_sinistra",
        "int": true,
        ext: true,
        nome: "AstaSx",
        testo: "",
        colore: ""
      }];
    }
  }, {
    key: "materiale",
    get: function get() {
      return this.$store.state.configurator.templesMaterial;
    }
  }, {
    key: "temple",
    get: function get() {
      return this.$store.state.configurator.coloreAste;
    }
  }, {
    key: "changeItem",
    value: function changeItem(val) {
      this.selectedItem = val;
    }
  }]);

  return Personalizzazioni;
}(Vue);

Personalizzazioni = __decorate([Component({
  components: {
    ComponenteIncisione: ComponenteIncisione
  }
})], Personalizzazioni);
export default Personalizzazioni;